/**
 * Subdomain detection utility for DealShaq domain architecture.
 * 
 * Detects if the current hostname is a retailer subdomain and extracts the slug.
 * Used for routing {retailerSlug}.dealshaq.com → /retailer/{retailerSlug}
 */

const ROOT_DOMAINS = ['dealshaq.com', 'www.dealshaq.com'];
const RESERVED_SUBDOMAINS = ['www', 'admin', 'marketing', 'api', 'mail', 'cpanel'];

export function getSubdomain() {
  const hostname = window.location.hostname;

  // Local development — no subdomain detection
  if (hostname === 'localhost' || hostname.includes('preview.emergentagent.com') || hostname.includes('vercel.app')) {
    return null;
  }

  // Root domain — no subdomain
  if (ROOT_DOMAINS.includes(hostname)) {
    return null;
  }

  // Extract subdomain
  const parts = hostname.split('.');
  if (parts.length > 2) {
    const subdomain = parts[0];
    if (!RESERVED_SUBDOMAINS.includes(subdomain)) {
      return subdomain;
    }
  }

  return null;
}

export function isRetailerSubdomain() {
  return getSubdomain() !== null;
}

export function getRetailerSlug() {
  return getSubdomain();
}
